import type { Locale } from "../../../core/schema/Locale.js";
import companyBanner from "../assets/images/company-banner.jpeg?webp&w=1920&imagetools";
import company from "../assets/images/company.jpeg?webp&h=580&imagetools";
import nature from "../assets/images/nature.jpeg?webp&h=580&imagetools";
import natureBanner from "../assets/images/nature.jpeg?webp&w=1920&imagetools";
import social from "../assets/images/social.png?webp&h=580&imagetools";
import socialBanner from "../assets/images/social.png?webp&w=1920&imagetools";
import { getTranslate } from "../utils/getTranslate.js";
import translations from "./esgStrategyAreas.translations.json";

interface EsgStrategyArea {
	id: string;
	name: string;
	content: string;
	perex: string;
	banner: string;
	image: string;
	points: string[];
}

export function getEsgStrategyAreas(locale: Locale): EsgStrategyArea[] {
	const translate = getTranslate(translations, false, locale);

	return [
		{
			id: "nature",
			name: translate("nature"),
			content: translate("natureContent"),
			perex: translate("naturePerex"),
			banner: natureBanner,
			image: nature,
			points: translate("naturePoints").split("\n"),
		},
		{
			id: "social",
			name: translate("social"),
			content: translate("socialContent"),
			perex: translate("socialPerex"),
			banner: socialBanner,
			image: social,
			points: translate("socialPoints").split("\n"),
		},
		{
			id: "company",
			name: translate("company"),
			content: translate("companyContent"),
			perex: translate("companyPerex"),
			banner: companyBanner,
			image: company,
			points: translate("companyPoints").split("\n"),
		},
	];
}
